<template>
  <div>
    <div v-show="isLoading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div class="container-fluid overflow-auto">
      <div class="row">
        <div class="col-12 pt-3 pb-3 pl-4 d-flex flex-wrap">
          <div class="col-12 col-md-6">
            <h3><i class="fa fa-user-circle"></i> Histórico de Atendimentos</h3>
          </div>
          <div class="col-12 col-md-6 text-md-right mt-3 mt-md-0">
            <div class="col-12 col-md-3 ml-auto">
              <defaultbutton
                class="defaultbutton"
                :onClick="() => onShowSearch()"
                btnVariant="btn-third"
                icon="fas fa-search"
                text="Pesquisar"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="row col-12 pt-3 pb-3 pl-4 d-flex flex-wrap">
        </div>
        <Conversations ref="conversations" class="atendimento-conversations"
          :localConversations="localConversations"
          :person="personDetails"
          @conversations-updated="handleConversationsUpdated"
          @changeTab="handleTabChange"
          @sendUpdateOperator="updataOperator"
          @sendAssumeOperator="assumeConversation"
        />
      </div>
      <div class="row" v-show="conversationIsNull && allConversations.length === 0">
        <div class="col-12 pt-3 pb-3 pl-1">
          <h4 class="ml-5">Não possui atendimentos</h4>
        </div>
      </div>
      <div class="pagination-controls">
        <nav aria-label="Page navigation example">
          <ul class="pagination justify-content-center">
            <li class="page-item">
              <a @click="goToFirstPage" :disabled="filters.page <= 1" class="page-link" href="#">Primeira</a>
            </li>
            <li class="page-item"><a @click="previousPage" :disabled="filters.page <= 1" class="page-link" href="#">Anterior</a></li>
            <li v-for="page in getPageRange()" :key="page" :class="['page-item', { 'active': page === filters.page }]">
              <a @click="goToPage(page)" class="page-link" href="#">{{ page }}</a>
            </li>
            <li class="page-item"><a @click="nextPage" :disabled="filters.page >= totalPages" class="page-link" href="#">Próximo</a></li>
            <li class="page-item">
              <a @click="goToLastPage" :disabled="filters.page >= totalPages" class="page-link" href="#">Última</a>
            </li>
            <ul class="pagination justify-content-center">
              <span class="page-link">
                {{ filters.page }} de {{ totalPages }}
              </span>
            </ul>
          </ul>
        </nav>
      </div>
    </div>
    <SidebarSearch @search="onSearch" />
  </div>
</template>

<script>
import Conversations from './components/conversations/Conversations.vue'
import { JWTService } from '@/shared/services/jwt'
import SidebarSearch from '@/views/private/atendimento/historico_atendimento/search/SidebarRelatorioAtendimento.vue'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import AccountMixin from '@/store/module/account/mixin'
import defaultbutton from '@/components/UI/button/defaultButton.vue'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'HistoricoAtendimento',
  components: {
    Conversations,
    defaultbutton,
    SidebarSearch
  },
  mixins: [AccountMixin],
  computed: {
    isMobile () {
      return window.innerWidth < 768
    }
  },
  data () {
    return {
      conversationsSubscription: null,
      conversations: [],
      personDetails: [],
      localConversations: [],
      countConversation: 0,
      conversationSubscription: null,
      conversationDispatchesSubscription: null,
      conversation: {
        conversationId: null,
        identifier: null
      },
      messages: [],
      stompClient: null,
      isConnected: false,
      isLoading: false,
      conversationIsNull: false,
      page: 1,
      currentPage: 1,
      activePage: null,
      pageSize: 12,
      totalPages: null,
      allConversations: [],
      filters: {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        dataInicial: null,
        dataFinal: null,
        operadores: ['all'],
        status: 'Finalizado',
        page: 1,
        pageSize: 12,
        fetchImages: true
      }
    }
  },
  mounted () {
    this.connect()
  },
  created () {
    this.getTiposFinalizacao()
  },
  beforeDestroy () {
    this.disconnect()
  },
  methods: {
    connect () {
      const socket = new SockJS(`${process.env.APIBaseBPM}/websocket`)
      this.stompClient = Stomp.over(socket)

      this.stompClient.connect({}, frame => {
        this.isConnected = true
        this.getConversations()
        this.getPages()
      }, error => {
        this.isConnected = false
        console.error('Connection error: ' + error)
      })
    },
    disconnect () {
      if (this.stompClient !== null) {
        this.stompClient.disconnect()
      }
    },
    getDuration (conversation) {
      const startDate = new Date(conversation.dateOpen)
      const endDate = new Date(conversation.dateFinalization)
      const duration = endDate - startDate
      const durationInMinutes = duration / 1000 / 60
      return durationInMinutes
    },
    refreshPage () {
      location.reload()
    },
    handleTabChange () {
      this.conversations = []
      this.getConversations()
    },
    assumeConversation (payload) {
      this.stompClient.send(`/app/conversations/updateOperator`, {}, JSON.stringify(payload))
      this.refreshPage()
    },
    clearConversations () {
      this.localConversations = []
    },
    load (params) {
      return AtendimentoRepository.getConversations(this.filters, { params })
    },
    updatePagination () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      this.localConversations = this.allConversations.slice(start, end)
      this.totalPages = Math.ceil(this.allConversations.conversations.length / this.pageSize)
    },
    getPageRange () {
      const totalPages = this.totalPages || 1
      const range = 5
      let startPage = Math.max(1, this.page - range)
      let endPage = Math.min(totalPages, this.page + range)

      if (endPage - startPage < range * 2) {
        if (startPage === 1) {
          endPage = Math.min(totalPages, startPage + range * 2)
        } else {
          startPage = Math.max(1, endPage - range * 2)
        }
      }

      return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i)
    },
    goToPage (page) {
      this.filters.page = page
      this.clearConversations()
      this.getConversations()
    },
    previousPage () {
      if (this.filters.page > 1) {
        this.filters.page--
        this.clearConversations()
        this.getConversations()
      }
    },
    nextPage () {
      if (this.filters.page < this.totalPages) {
        this.filters.page++
        this.clearConversations()
        this.getConversations()
      }
    },
    goToFirstPage () {
      if (this.filters.page !== 1) {
        this.filters.page = 1
        this.clearConversations()
        this.getConversations()
      }
    },
    goToLastPage () {
      if (this.filters.page !== this.totalPages) {
        this.filters.page = this.totalPages
        this.clearConversations()
        this.getConversations()
      }
    },
    handleConversationsUpdated (data) {
      this.conversations = data
    },
    async getPages () {
      const requestConfigPages = {
        status: this.filters.status,
        operatorId: this.filters.operadores,
        startDate: this.filters.dataInicial ? new Date(this.filters.dataInicial).toISOString() : null,
        endDate: this.filters.dataFinal ? new Date(this.filters.dataFinal).toISOString() : null,
        typeFinalization: this.filters.tipoFinalizacao
      }

      await AtendimentoRepository.GetPages(this.filters, requestConfigPages)
        .then(response => {
          const { status, data } = response

          if (status === 200) {
            this.countsConversation = data.count
            this.totalPages = Math.ceil(this.countsConversation / this.filters.pageSize)
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    getPa () {
      if (this.account && this.account.funcionario) {
        if (JWTService.GetRoles().includes('OPERADOR_ATENDIMENTO_GERAL')) {
          return 'all'
        } else if (JWTService.GetRoles().includes('OPERADOR_ATENDIMENTO') && this.account.funcionario.paId) {
          return this.account.funcionario.paId[0]
        } else {
          return 'all'
        }
      }
    },
    async getConversations () {
      loading.push()
      this.conversationIsNull = false

      const requestConfig = {
        params: {
          status: 'Finalizado',
          operatorId: ['all'],
          startDate: this.filters.dataInicial ? new Date(this.filters.dataInicial).toISOString() : null,
          endDate: this.filters.dataFinal ? new Date(this.filters.dataFinal).toISOString() : null,
          page: this.filters.page,
          pageSize: this.filters.pageSize,
          typeFinalization: this.filters.tipoFinalizacao,
          fetchImages: true
        }
      }

      try {
        const response = await AtendimentoRepository.GetConversations(this.filters, requestConfig)
        const { status, data } = response

        if (status === 200) {
          this.allConversations = data
          this.updatePagination()
        } else {
          this.conversationIsNull = true
          loading.pop()
        }
      } catch (error) {
        console.error(error)
        this.conversationIsNull = true
      } finally {
        loading.pop()
      }
    },
    updataOperator (payload) {
      this.stompClient.send(`/app/conversations/updateOperator`, {}, JSON.stringify(payload))
      this.refreshPage()
    },
    onSearch (filters) {
      this.filters = filters
      this.$nextTick(() => {
        this.getPages()
        this.getConversations()
      })
    },
    onLoadAll () {
      loading.push()
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>

<style lang="scss" scoped>
.atendimento-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .atendimento-nav {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    padding: 0 1rem;
    margin-bottom: 5px;
    border-bottom: solid 1px #e6e6e6;
    background-color: #fff;

    span {
      color: #006a5b !important;
      font-weight: 700;
      font-size: 16px;
    }
  }

  .atendimento {
    display: flex;
    height: 100%;

    .atendimento-conversations {
      width: 20% !important;
      max-width: 20%;
      min-width: 300px;
    }

    .atendimento-chat {
      width: 60% !important;
      min-width: 300px;
    }

    .atendimento-detail {
      width: 20% !important;
      max-width: 25%;
      min-width: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/historico_atendimento/historicoAtendimento.vue